import React, {useEffect, useState} from "react";
import Page from "../../Components/Page";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import EditableReactTableV2 from "../../Components/ReactTable/EditableReactTableV2";
import {
    EditFormMultiDropdownInputField,
    EditFormNumberInputField,
    EditFormTextInputField
} from "../../Components/ReactTable/EditRecordForm";
import moment from "moment";
import {setValuesToNullIfEmptyOrUndefined} from "../../Components/ReactTable/helpers";
import {makeApiCall} from "../../../Api/makeApiCall";

function BrandOnboarding() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/brandOnboarding/`;
    const { loading, data , onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({ endpointUrl });
    const [browseNodesDropdownOptions, setBrowseNodesDropdownOptions] = useState([]);

    function mkEdpApiUrl() {
        const path = encodeURIComponent(`gs://spins-edp-${process.env.REACT_APP_ENV}-services/browseNodes/result.json`);
        return `${process.env.REACT_APP_EDP_API_BASE_URL}/getGcsFileByPath/?path=${path}`;
    }

    useEffect(() => {
        makeApiCall(mkEdpApiUrl())
            .then((data) => {
                // noinspection
                setBrowseNodesDropdownOptions(data['data'])
            });
    }, []);

    const onRowEditConfirmedWrapper = async (newOrUpdatedData) => {
        const current_date = moment(Date.now()).format("YYYY-MM-DD HH:mm:ss");

        const newData = {...newOrUpdatedData, date_created: current_date};
        await onRowEditConfirmed(setValuesToNullIfEmptyOrUndefined(newData));
    }

    const customColumns = [
        {
            header: "Brand Id",
            id: "brand_id",
            filterable: true,
            accessorKey: "brand_id",
            size: 20,
        },
        {
            header: "Brand",
            accessorKey: "brand_name",
            cell: ({ row }) => <a href={"/brandOnboarding/"+row.original.brand_id+"?brandName=" + row.original.brand_name} target="_blank" rel="noopener noreferrer">{row.original.brand_name}</a>,
        },
        {
            header: "Parent Brand",
            accessorKey: "parent_brand"
        },
        {
            header: "Keywords",
            accessorKey: "keywords"
        },
        {
            header: "Browse Nodes",
            accessorKey: "browseNodes"
        },
        {
            header: "Source",
            accessorKey: "source"
        },
        {
            header: "Status",
            accessorKey: "status"
        },
        {
            header: "Date Created",
            accessorKey: "date_created",
        },

    ];
    return (
        <Page name={"Brand Onboarding"}
              breadCrumbs={<Breadcrumbs items={[{label: "MAP Enforcement"}, {label: "Brand Onboarding"}]}/>}>
            <LoadingWrapper loading={loading}>
                <EditableReactTableV2
                    filterable
                    data={data}
                    columns={customColumns}
                    initialState={{ pagination: { pageSize: 25 }, sorting: [{ id: "brand_id", desc: false }] }}
                    editTable={[
                        {id: "brand_id", Component: args => <EditFormNumberInputField  {...args}  disabled label={"Brand Id"} />},
                        {id: "brand_name", Component: args => <EditFormTextInputField  {...args} isRequired label={"Brand"}/>},
                        {id: "parent_brand", Component: args => <EditFormTextInputField  {...args} label={"Parent Brand"} />},
                        {id: "keywords", Component: args => <EditFormTextInputField  {...args} label={"Keywords"} />},
                        {id: "browseNodes", Component: args => <EditFormMultiDropdownInputField {...args} label={"Browse Nodes"} options={browseNodesDropdownOptions} />},
                        {id: "source", Component: args => <EditFormTextInputField  {...args} label={"Source"} />},
                        {id: "status", Component: args => <EditFormTextInputField  {...args} label={"Status"} />},
                    ]}
                    onRowEditConfirmed={onRowEditConfirmedWrapper}
                    onRowDeleteConfirmed={onRowDeleteConfirmed}
                />
            </LoadingWrapper>
        </Page>
    );
}

export default BrandOnboarding;
